/**
 * @voltxampere/ui — Common-mode choke variant (Sprint 44-6, placeholder)
 *
 * PLACEHOLDER. Common-mode (CM) choke — EMI/EMC filtre. İki
 * winding aynı core, aynı yön (CM gürültüyü reddet, differential
 * sinyale şeffaf). Tek winding `inductor` üzerinden modellenir;
 * dual winding + tight coupling (k≈0.99) Sprint 47+ engine
 * extension #4 ile (coupled inductor stamp).
 *
 * Reference: Generic CM choke — Würth WE-CMB 744225 serisi,
 * Murata DL serisi. L_CM = 470 µH @ 100 kHz, I_DC = 800 mA per
 * winding. AC mains line filter, USB/Ethernet EMI suppression,
 * SMPS giriş filtresi.
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const magneticCmChoke = {
    id: "magnetic-cm-choke",
    nameTr: "Common-Mode Choke (Würth WE-CMB, placeholder)",
    nameEn: "Common-Mode Choke (Würth WE-CMB, placeholder)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "L",
    defaultValue: "CM-470µH",
    schemaType: "inductor",
    defaultParams: { inductance: 470e-6 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=magnetic-cm-choke.js.map